function ItemSurah({
  nomor,
  namaSurah,
  artiSurah,
  tempatTurunSurah,
  jumlahAyat,
}) {
  return (
    <div className="h-24 w-full border-b-2 border-teal-300 flex mb-4 hover:cursor-pointer">
      <div className="lg:basis-12 basis-5 flex justify-end mr-4">
        <h3 className="text-white text-lg font-bold">{nomor}</h3>
      </div>
      <div className="flex flex-col">
        <h3 className="text-white text-lg font-bold">{namaSurah}</h3>
        <h5 className="text-gray-300 text-sm font-bold">{artiSurah}</h5>
        <span className="text-gray-300 text-sm font-normal">
          {tempatTurunSurah}, {jumlahAyat} Ayat
        </span>
      </div>
    </div>
  );
}

export default ItemSurah;
